import { Component, OnInit } from '@angular/core';
import { State } from '@progress/kendo-data-query';
import { DialogRef, DialogContentBase } from '@progress/kendo-angular-dialog';
import { GridDataResult } from '@progress/kendo-angular-grid';

import { UserService } from '../user.service';
import { GridService } from 'src/app/shared/grid.service';

@Component({
  selector: 'app-user-popup',
  templateUrl: './user-popup.component.html',
  styleUrls: ['./user-popup.component.scss'],
})
export class UserPopupComponent extends DialogContentBase implements OnInit {
  oDataStr = '';
  title = '';
  button_cancel = '';

  isLoading = false;
  gridView!: GridDataResult;
  id!: number;

  pageable = {
    pageSizes: this.gridService.pageSizes,
  };

  public state: State = {
    take: this.gridService.take,
    skip: 0,
  };

  constructor(
    public override dialog: DialogRef,
    public gridService: GridService,
    private userService: UserService
  ) {
    super(dialog)
  }

  ngOnInit(): void {
    // api call odata
    this.refreshList();
  }

  refreshList() {
    this.isLoading = true;
    if (this.oDataStr) {
      this.userService
      .odataStr(this.state, this.oDataStr)
      .subscribe((response) => {
        this.isLoading = false;
        this.gridView = {
          data: response.value,
          total: response['@odata.count'],
        };
      });
    }
    else {
      this.userService
      .odata(this.state)
      .subscribe((response) => {
        this.isLoading = false;
        this.gridView = {
          data: response.value,
          total: response['@odata.count'],
        };
      });
    }
    
  }

  cancel() {
    this.dialog.close(false);
  }

  select(e: any) {
    this.dialog.close(e.dataItem);
  }

  dataStateChange(state: State) {
    this.isLoading = true;
    this.gridService.setRowPerPages(state);
    this.state = state;
    this.refreshList();
  }
}
